/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { NAVIGATION_ROUTES } from '../../../shared/constants/Constants';

function AccountsPageHorizontalBar({ selectedPage }) {
  const navigate = useNavigate();
  const selectedRef = useRef(null);
  useEffect(() => {
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth',
      });
    }
  }, [selectedPage]);
  const ACCOUNT_PAGES = [
    {
      name: 'My Bookings',
      tab: 'my-bookings',
      route: NAVIGATION_ROUTES.MY_BOOKINGS_ROUTE,
    },
    {
      name: 'Agent-Ledger',
      tab: 'agent-ledger',
      route: NAVIGATION_ROUTES.PROFILE.LEDGER,
    },
    { name: 'Online Payment', tab: 'online-payment', route: '/balance-upload' },
    { name: 'Offline Payment', tab: 'offline-payment', route: '/make-payment' },

    { name: 'Reports', tab: 'reports', route: '/reports' },
    {
      name: 'Agent Markup',
      tab: 'agent-markup',
      route: NAVIGATION_ROUTES.AGENT_MARKUP,
    },
    {
      name: 'Manage Bookings',
      tab: 'manage-bookings',
      route: NAVIGATION_ROUTES.MANAGE_ALL_BOOKINGS,
    },
    {
      name: 'Add/View Staff',
      tab: 'add-view-staff',
      route: NAVIGATION_ROUTES.PROFILE.STAFF_ROUTE,
    },
    // {
    //   name: 'Group Booking',
    //   tab: 'group-booking',
    //   route: NAVIGATION_ROUTES.FLIGHT.FLIGHT_GROUP_BOOKING,
    // },
  ];
  return (
    <div className="accounts-page_horizontal-bar">
      <div className="accounts-page_horizontal-bar_container">
        {ACCOUNT_PAGES.map((page, index) => (
          <div
            key={index}
            ref={selectedPage === page.tab ? selectedRef : null}
            className={`accounts-page_horizontal-bar_option ${
              selectedPage === page.tab
                ? 'accounts-page_horizontal-bar_option_selected'
                : ''
            }`}
            onClick={() => navigate(page.route)}
          >
            {page.name}
          </div>
        ))}
      </div>
    </div>
  );
}
AccountsPageHorizontalBar.propTypes = {
  selectedPage: PropTypes.any.isRequired,
};

export default AccountsPageHorizontalBar;
